export const projectData = [
  {
    id: 'mock-interviews',
    title: 'Mock Interviews With Yiyan',
    subtitle: 'Web Application | April 2026',
    description: 'Calendar booking platform for my mock interview side hustle, where I help other students land their dream offers.',
    summary: 'Mock interview booking platform that integrates Stripe, Google Calendar API, and Google STMP to handle payments, email confirmations, and calendar invites.',
    image: '/images/projects/interview.png',
    technologies: ['python', 'typescript', 'flask', 'react', 'restapi'],
    github: 'https://github.com/yiyan023/mock-interview-frontend',
    demo: 'https://mock-interview-frontend-black.vercel.app/',
    hasDemo: true
  },
  {
    id: 'telescope',
    title: 'Telescope',
    subtitle: 'MCP Middleware | July 2025',
    description: 'Aims to improve security and observability for MCP servers.',
    summary: 'Telescope is a MCP proxy that tracks MCP server access and protects clients from malicious MCPs, data theft and prompt injections.',
    image: '/images/projects/telescope.png',
    technologies: ['python', 'typescript', 'flask', 'react', 'restapi'],
    github: 'https://github.com/yiyan023/sentinel-proxy-vision',
    demo: 'https://drive.google.com/file/d/1ZAR6izUWMK85MsXIHORMQ8U4HHO6HSUN/view?usp=sharing',
    hasDemo: true
  },
  {
    id: 'easyware',
    title: 'Easyware',
    subtitle: 'AI Application | May 2025',
    description: 'Aims to streamline pain points for hardware developers.',
    summary: 'Easyware is an AI-powered tool that helps hardware developers convert ideas into schematic, pcb and 3D models.',
    image: '/images/projects/easyware.png',
    technologies: ['python', 'typescript', 'flask', 'react', 'restapi'],
    github: 'https://github.com/fengzhang789/Easyware/tree/main',
    demo: 'https://www.youtube.com/watch?v=U1jhCoc070E&ab_channel=YiyanHuang',
    hasDemo: true
  },

  {
    id: 'acceleratr',
    title: 'Acceleratr',
    subtitle: 'Web Application | Nov 2024',
    description: 'Aims to streamline the job application process',
    summary: 'Full stack resume builder that converts user experiences into a Latex, ATS-friendly PDF.',
    image: '/images/projects/acceleratr.png',
    technologies: ['python', 'typescript', 'flask', 'react', 'restapi'],
    github: 'https://github.com/richieb21/ctrl-hack-del',
    demo: 'https://drive.google.com/file/d/1PTT6UETn8ea1TVzprZ8ev-qGRd4Wx0FH/view?usp=sharing',
    hasDemo: true
  },
  {
    id: 'pizzastudio',
    title: 'PizzaStudio',
    subtitle: 'Mobile Application | Sept 2024',
    description: 'Aims to help women who experience domestic abuse win legal cases. Winner of Best Gender Equality Hack at TechNova 2024.',
    summary: 'Mobile project that allows victims of domestic abuse secretly collect evidence by ordering pizza. They can access previous recordings in their order history.',
    image: '/images/projects/pizzastudio.png',
    technologies: ['python', 'flask', 'react', 'typescript', 'mongodb'],
    github: 'https://github.com/yiyan023/pizza-studio',
    demo: 'https://drive.google.com/file/d/1s9PhzUJsWfZdTr_rSDXpRwMwfgj_fo2S/view?usp=sharing',
    hasDemo: true
  },
  {
    id: 'tunescriber',
    title: 'TuneScriber',
    subtitle: 'Web Application | Aug 2024',
    description: 'Aims to provide accessible music education.',
    summary: 'TuneScriber is a full-stack web app that converts audio files into sheet music (one per instrument).',
    image: '/images/projects/tunescriber.png',
    technologies: ['python', 'javascript', 'flask', 'react', 'restapi'],
    github: 'https://github.com/yiyan023/TuneScriber',
    demo: 'https://drive.google.com/file/d/1oFRm2GzZL6RhDWPMNlYBwds8h-xtpKI5/view?usp=sharing',
    hasDemo: true
  },
  {
    id: 'brailleenglish',
    title: 'BrailleEnglish',
    subtitle: 'Terminal Tool | Aug 2024',
    description: 'Aims to make writing more accessible for the visually impaired.',
    summary: 'Terminal/command-line project that converts English to Braille (and vice versa). Built for the Shopify Winter 2025 Engineering Challenge.',
    image: '/images/projects/english-braille.png',
    technologies: ['python'],
    github: 'https://github.com/yiyan023/yiyan-eng-intern-challenge/blob/python/python/translator.py',
    demo: 'https://drive.google.com/file/d/1FjCIM7lAIfbrFXWjPs0j-75zUTHzlEWP/view?usp=sharing',
    hasDemo: true
  },
  {
    id: 'travelbuddy',
    title: 'TravelBuddy',
    subtitle: 'Mobile Application | Feb 2024',
    description: 'Aims to make travel more convenient for everyone',
    summary: 'Travel Buddy is a mobile application that allows users to access nearby restaurants using the Yelp API and React Native Location Service.',
    image: '/images/projects/travelbuddy.png',
    technologies: ['javascript', 'react', 'restapi'],
    github: 'https://github.com/yiyan023/Travel-Buddy',
    demo: 'https://drive.google.com/file/d/1gxdy7aW8iaw1YLzCLXtEkoi8r8feSEY0/view?usp=sharing',
    hasDemo: true
  },
  {
    id: 'youwriter',
    title: 'YouWriter',
    subtitle: 'Web Application | Jan 2024',
    description: 'Aims to increase note-taking efficiency for students of all demographics',
    summary: 'YouWriter is a full-stack web application that converts any YouTube video into a written summary.',
    image: '/images/projects/youwriter.png',
    technologies: ['javascript', 'python', 'react', 'flask', 'mongodb'],
    github: 'https://github.com/yiyan023/YouWriter',
    demo: 'https://drive.google.com/file/d/19wz9ZFHrJbSOO6o8WEhHr_qE1zhK1pAO/view?usp=sharing',
    hasDemo: true
  },
  {
    id: 'deaflink',
    title: 'DeafLink',
    subtitle: 'Machine Learning Model | Nov 2023',
    description: 'Aims to bridge global communication barriers in the deafmute community',
    summary: 'Deaf Link is a machine learning model that was trained with 2600+ images to convert ASL hand signs to English letters in real-time.',
    image: '/images/projects/deaflink.png',
    technologies: ['python', 'opencv', 'scikit-learn'],
    github: 'https://github.com/yiyan023/DeafLink',
    hasDemo: false
  },
  {
    id: 'ingredientsafe',
    title: 'IngredientSafe',
    subtitle: 'Web Application | Dec 2022',
    description: 'Aims to help the visually impaired avoid allergic reactions',
    summary: 'IngredientSafe is a full-stack web application that scans food labels and returns potential allergens to the user.',
    image: '/images/projects/ingredientsafe.png',
    technologies: ['javascript', 'python', 'opencv', 'flask'],
    github: 'https://github.com/yiyan023/IngredientSafe',
    hasDemo: false
  },
];

export const techIcons = {
  javascript: 'javascript.png',
  python: 'python.png',
  react: 'react.png',
  flask: 'flask.png',
  mongodb: 'mongodb.png',
  opencv: 'opencv.png',
  'scikit-learn': 'scikit-learn.png',
  restapi: 'restapi.png',
  flutter: 'flutter.png',
  typescript: 'typescript.png'
};
